export const METERS_PER_SEC_TO_MPH_FACTOR = 2.237;
